<script>

export default {
    name: "publishFilterSelect",
    props: {
        items: Array,
        selectedItem: String,
        label: String,
        clearable: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        prefix() {
            return this.label + (this.selectedItem === '' ? '' : ':');
        }
    }
}
</script>

<template>
    <v-autocomplete-custom
        :aria-label="label"
        :items="items"
        :prefix="prefix"
        :value="selectedItem"
        :clearable="clearable"
        @input="$emit('input', $event)"
    />
</template>
